import React, {Component} from 'react';
import style from './sample.module.css';
import Logo from '../../image/icon/index_logo.png';
import Menu from '../../image/icon/icon_menu.png';
import SeeAll from '../../image/icon/see_all.png';
import Jiantou from '../../image/icon/jiantou.png';
import $ from  'jquery';
import creatHistory from 'history/createHashHistory';
import MenuSide from "../../compents/menuSid/MenuSide";
import {Link} from "react-router-dom";

class sample extends React.Component {


    constructor(props) {
        super(props);
        this.state = {
            data:null,
            isMobile:false,
            menuState:false
        };
        // this.indexChange.bind(this);
    }


    seeAll=()=>{
        const history = creatHistory();
        history.goBack();
    }
    goHome=()=>{
        this.props.history.push('/')
    }
    showMenu=()=>{
        this.setState({
            menuState:!this.state.menuState
        })
    }
    render() {
        return (
            this.state.data!==null? <div className={style.project_info}>
                {this.state.isMobile?<div className={style.header}>
                    <img className={style.logo} src={Logo} title="HOME" onClick={this.goHome}/>
                    <img className={style.menu} src={Menu} title="Menu" onClick={(e)=>this.showMenu(e)}/>
                </div>:<div className={style.header}>
                    <img className={style.logo} src={Logo} title="HOME" onClick={this.goHome}/>
                    <ul>
                        <li>公司行业</li>
                        <li>关于我们</li>
                        <li>加入我们</li>
                        <li>联系我们</li>
                    </ul>
                </div>}
                <h2>页面还在建设中...</h2>
                <div className={style.see_all} onClick={this.seeAll}>
                    <img src={SeeAll}/>
                    <p>查看所有案例</p>
                </div>
                <div className={style.footer} onClick={this.handleScrollTop}>
                    <div className={style.top_btn}>
                        <img src={Jiantou}/>
                        <p>顶部</p>
                    </div>
                    <ul>
                        <li>关于我们</li>
                        <li>加入我们</li>
                        <li>联系我们</li>
                    </ul>
                    <div className={style.bottom}>
                        <p>Copyright © 2019 eyemove.All right reserved</p>
                        <p> 沪ICP备15012399号-1</p>
                    </div>
                </div>
                <MenuSide menuState={this.state.menuState} close={(e)=>this.showMenu(e)}></MenuSide>
            </div>:""
        );
    }
}

export default sample;